import "./profile.css";

import { Button, Col, Container, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";

import { UserQuestionnaire } from "../PreSurvey/PreSurveyQuestionnaire";
import { useSelector } from "react-redux";
import { useUser } from "../../contexts/UserProvider";

export default function ProfilePage() {
  const { user } = useUser();
  const [showUpdateDetails, setShowUpdateDetails] = useState(false);
  const presurvey_info = useSelector((state) => state.user.presurvey_form.form);

  useEffect(() => {
    document.body.style.overflow = showUpdateDetails ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showUpdateDetails]);

  const handleCloseModal = (e) => {
    if (e.target.classList.contains("questionnaire-modal")) {
      setShowUpdateDetails(false);
    }
  };
  return (
    <>
      <Container
        style={{
          marginTop: "2%",
          padding: "20px",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
        }}
      >
        <h1>User Profile</h1>
        <Row></Row>
        <Row className="mb-3">
          <Col md={6}>
            <strong>Username:</strong> {user.username}
          </Col>
          <Col md={6}>
            <strong>Email:</strong> {user.email}
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <strong>Age:</strong> {presurvey_info.age}
          </Col>
          <Col md={6}>
            <strong>Gender:</strong> {presurvey_info.gender}
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <strong>Position:</strong> {presurvey_info.position}
          </Col>
          <Col md={6}>
            <strong>Hospital:</strong> {presurvey_info.hospital}
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <strong>NHS Region:</strong> {presurvey_info.nhs_region}
          </Col>
          <Col md={6}>
            <strong>Hospital Type:</strong> {presurvey_info.hospital_type}
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <strong>Total number of hospital beds:</strong>{" "}
            {presurvey_info.beds}
          </Col>
          <Col md={6}>
            <strong>Years of professional experience:</strong>{" "}
            {presurvey_info.experience_pq}
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <strong>Years of infection control experience:</strong>{" "}
            {presurvey_info.experience_ipc}
          </Col>
          <Col md={6}>
            <strong>Technology Proficiency (1-10):</strong>{" "}
            {presurvey_info.tech_proficiency}
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <strong>Contact Tracing Proficiency (1-10):</strong>{" "}
            {presurvey_info.trace_proficiency}
          </Col>
          <Col md={6}>
            <strong>
              Genetic Information Interpreting Proficiency (1-10):
            </strong>{" "}
            {presurvey_info.genetic_proficiency}
          </Col>
        </Row>
        <Button onClick={() => setShowUpdateDetails(!showUpdateDetails)}>
          Update Details
        </Button>
        {showUpdateDetails && (
          <>
            <div
              className="questionnaire-modal"
              onClick={handleCloseModal}
            ></div>
            <UserQuestionnaire
              className="questionnaire-modal-content"
              context={"update"}
            />
          </>
        )}
      </Container>
    </>
  );
}
